import React from 'react';

const TopLevelErrorMessage = () => (
  <>
    <h1>Ooops... something went wrong</h1>
    <p>Your error has been automatically reported and will be investigated</p>
    <p>
      You can try to refresh the application and see if it&apos;s just a
      temporary issue.
    </p>
    <p>
      We regret the inconvenience and hope to have you up and running soon
      again!
    </p>
  </>
);

export default TopLevelErrorMessage;
